import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getChildEdgeTypeId, getParentEdgeTypeId } from '@iotv/datamodel';
import { useContext } from 'react';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { AdjacentType, ComparisonType, LogicalOperatorType, } from '../../types/AppTypes';
import { ObjectDetailCard } from '../../v2/components/generic/ObjectView/ObjectDetailCard';
import { getViewDefintionFromObject } from '../factories/AttributeDefinitions';
import { Listerlizer } from '../factories/Listerlizer/Listerlizer';
const debug = process.env.REACT_APP_DEBUG && false;
/** Automatically creates a tab with relevant list based on context object (parent) and view object */
const AutoAdjacentTab = (props) => {
    const { tabDef: t, contextObject, mostProximateCustomer, viewObject, userFunctions, transactionFunctions, newObjectDefinition, autoQuery, contextCustomer, } = props;
    debug && console.log(`EntityTab for ${t.type} viewObject`, viewObject);
    const [{ applicationData }] = useContext(AppMainViewContext);
    const viewDefinition = t.viewDefinition ?? getViewDefintionFromObject({ type: t.type });
    const filteredViewDefinition = Object.fromEntries(Object.entries(viewDefinition).filter(([key, definition]) => definition.hideFromList !== true));
    /** Construct adjacent filter used for querying listerlizer */
    const filterGroups = [
        {
            filters: t.constraints?.map((constraint) => {
                return { key: constraint.key, value: constraint.value, predicate: constraint.predicate ?? ComparisonType.EQUALS };
            }) ?? [],
            setOperation: t.allOrAny ? (t.allOrAny === 'all' ? LogicalOperatorType.AND : LogicalOperatorType.OR) : LogicalOperatorType.AND,
        },
    ];
    debug && console.log('AutoTab: filterGroups', filterGroups);
    // Edge Type ID
    debug && console.log('AutoTab: getChildEdgeTypeId', t.type, contextObject.type, t.direction);
    const edgeTypeId = t.edgeTypeId ?? (t.direction === AdjacentType.PARENT ? getParentEdgeTypeId(contextObject.type, t.type) : getChildEdgeTypeId(contextObject.type, t.type));
    const estimatedId = (t.direction === AdjacentType.PARENT ? `${t.type}_has_${contextObject.type}` : `${contextObject.type}_has_${t.type}`).toLocaleLowerCase();
    const edgeFilter = { edgeTypeId: edgeTypeId ?? estimatedId };
    debug && console.log(`AutoTab for ${t.type} edgeTypeId`, edgeTypeId, 'edgeFilter', edgeFilter);
    const contextObjectToGroupAdjacentFilter = {
        adjacentType: t.direction ?? AdjacentType.CHILD,
        objectType: t.type,
        filterConfig: filterGroups,
        edgeFilter,
    };
    debug && console.log('AutoTab viewObject', viewObject);
    return !props.tabDef.singleObject && applicationData ? (_jsx(Listerlizer, { mostProximateCustomer, viewObject, contextObject, initialSort: [{ field: Object.values(filteredViewDefinition)[0]?.key ?? 'name', sort: 'asc' }], autoQuery: autoQuery === undefined ? true : autoQuery, adjacentFilter: contextObjectToGroupAdjacentFilter, userFunctions: userFunctions, viewDefinition: filteredViewDefinition, newObjectViewDefinition: newObjectDefinition, transactionFunctions: transactionFunctions, searchRootObjects: contextCustomer ? [contextCustomer] : undefined, applicationData: applicationData })) : viewObject.matchedPrimary !== undefined ? (_jsx(ObjectDetailCard, { transactionFunctions,
        userFunctions,
        mostProximateCustomer,
        viewDefinition: viewDefinition,
        matchedPrimary: viewObject.matchedPrimary,
        applicationData })) : (_jsx(_Fragment, {}));
};
/** Takes an auto tab def and info and renders component appropriately */
export const AutoTab = (props) => {
    if (props.tabDef.type) {
        return _jsx(AutoAdjacentTab, { ...props });
    }
    else if (props.tabDef.component) {
        return props.tabDef.component;
    }
    else {
        return _jsx(_Fragment, {});
    }
};
